import { ReactComponent as Arrow } from '../../../assets/svg/ArrowDownPerm.svg';

function TableCollapsibleArrow() {
    return (
        <span className="table-list__collapsible-arrow">
            <Arrow />
        </span>
    )
}

export default TableCollapsibleArrow;
